import React, { useContext } from 'react';
import styled from 'styled-components';
import { Alert } from 'antd';
import AuthContext from '../../contexts/auth/authContext';

const StyledRegistered = styled.div`
    text-align: center;

    height: 100vh;

    img {
        height: 70vh;
    }
`;

const PostRegister: React.FunctionComponent = () => {
    const authContext = useContext(AuthContext);
    const { closeSession } = authContext;

    const { search } = window.location;
    const params = new URLSearchParams(search);

    const error = params.get('error');

    const outAndHome = () => {
        closeSession();
        window.location.replace('/');
    };

    return (
        <div>
            <StyledRegistered>
                <img alt="waiting for validation" src="../../../../assets/images/Artboard5.png" />
                {error ? (
                    <Alert
                        style={{ width: '50vh', margin: '0 auto 35px auto' }}
                        message="The link you used to verify your email is not valid anymore. Please contact Stuart's Solutions team for more info."
                        type="error"
                    />
                ) : (
                    ''
                )}
                <h1>Waiting for email validation</h1>
                <p>Your email is not verified yet. Please check your email and follow the steps to verify it.</p>
                <button type="button" onClick={outAndHome} className="btn btn-primary">
                    Back to home page
                </button>
            </StyledRegistered>
        </div>
    );
};

export default PostRegister;
